import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { ORDER_NEW_CARD, QUERY_ACCOUNT } from "../../../api/queryKeys";
import { APIStandardError, MutationOrderNewCardResponse } from "../../../types";

export default function useOrderNewCard() {
  const queryClient = useQueryClient();
  return useMutation<
    MutationOrderNewCardResponse,
    AxiosError<APIStandardError>
  >(() => api.post(ORDER_NEW_CARD).then((res) => res.data), {
    onError: (error) => {
      if (error.response?.data.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error("Unable to order a new card");
      }
    },
    onSuccess: () => {
      queryClient.refetchQueries([QUERY_ACCOUNT]);
    },
  });
}
